export function formatBooleanToYesNo(bool: boolean) {
  return bool ? 'Yes' : `No`
}